import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_admin/users')({
  component: Users,
});

export function Users() {
  return <div>Hello, users page.</div>;
}
